import { useMemo } from "react";
import useSettingsConfig from "../../../hooks/useSettingsConfig";
import { TableCell, TableRow } from "@mui/material";
import { getArrayIsNotEmpty } from "../../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { getSecondsFromStringTime } from "../../../../SharedComponents/utils/helpers/dateHelpers";
import DynamicTimeLabel from "../../Labels/DynamicTimeLabel";
import { useNavigate } from "react-router-dom";

const ActiveCarRequestTableRow = ({
    carRequest
}) => {
    const navigate = useNavigate();

    const GetImageComponent = () => {
        let imgSource = '';

        const requestHaveImages = getArrayIsNotEmpty(carRequest.PartRequestImages);

        if (requestHaveImages) {
            imgSource = carRequest.PartRequestImages[0].small_part_request_image_url;
        };

        const ImageComponent = (
            <div style={styles.imageContainer}>
                <img
                    src={imgSource}
                    style={styles.imageStyle}
                />
            </div>
        );

        return imgSource
            ? ImageComponent
            : <div />
    };


    const GetDynamicTextLabelCell = () => {
        const { settingsConfig } = useSettingsConfig();

        const collectOffersTime = useMemo(
            () => getSecondsFromStringTime(settingsConfig?.part_request_accepting_offers_time_value, settingsConfig?.part_request_accepting_offers_time_part),
            [settingsConfig]
        );


        const selectWinnerTime = useMemo(
            () => getSecondsFromStringTime(settingsConfig?.part_request_selecting_offer_time_value, settingsConfig?.part_request_selecting_offer_time_part),
            [settingsConfig]
        );


        return (
            <DynamicTimeLabel
                createdAt={carRequest.createdAt}
                state={carRequest.state}
                collectOffersTime={collectOffersTime}
                selectWinnerTime={selectWinnerTime}
            />
        );
    };

    const handleOpenSingleRequestPage = (id) => {
        navigate(`/part-request/${id}`);
    };


    return (
        <TableRow
            onClick={() => handleOpenSingleRequestPage(carRequest.part_request_id)}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell>
                {GetImageComponent()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.title}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {GetDynamicTextLabelCell()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.partOfferCount}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {carRequest.description}
            </TableCell>

        </TableRow>
    )
};


export default ActiveCarRequestTableRow;

const styles = {
    imageContainer: {
        width: 32,
        height: 32,
        borderRadius: 4
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 4
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0,0,0,0.87)"
    }
};